import { PluginFunction } from 'vue';
import { formatImageUrl, getProperSize, sizesInColumns } from '@/helpers/images';

export const Images: PluginFunction<any> = (Vue) => {
	Vue.filter('imageUrl', formatImageUrl);
	Vue.mixin({
		methods: {
			formatImageUrl,
			getProperSize,
			sizesInColumns
		}
	});
}

declare module "vue/types/vue" {
	interface Vue {
		formatImageUrl: typeof formatImageUrl;
		getProperSize: typeof getProperSize;
		sizesInColumns: typeof sizesInColumns;
	}
}
